export default __webpack_public_path__ + "static/media/loader.09d9c73f.svg";